import $ from "jquery"

$('.markets-area').on('click', function () {
  var target = $(this).data('target');
  var content = "";

  content = $(this).parent('div').siblings();
  if ($(this).hasClass('markets-area--active')) {
    $(this).parent().children('.markets-area__text').css('opacity', '');
    $(this).parent().children('.markets-area__text').css('height', '');
    $(this).parent().children('.markets-area__text').removeClass('markets-area--active');
    $(this).removeClass('markets-area--active');
  } else {
    var height = $(this).next().children('img').height() + $(this).next().children('div:first-of-type').height() + $(this).next().children('div:nth-of-type(2)').height() + $(this).next().children('a').height();
    $('.markets-area').removeClass('markets-area--active')
    $(this).toggleClass('markets-area--active');
    $(this).next().toggleClass('markets-area--active').css('height', height + 90).css('opacity', '1');
    $(content).find('.markets-area').removeClass('d-none');
    $(content).find('.markets-area__text').removeClass('markets-area--active').css('opacity', '0').css('height', '');
    setTimeout(function() {
      $('html, body').animate({
          scrollTop: $('.markets-area.markets-area--active').parent().offset().top - 100
      }, 0);
  }, 600);
  }
});

//first element open by default on mobile
$(window).on('load', function() {
  var height = $('.markets-area').first().next().children('img').height() + $('.markets-area').first().next().children('div:first-of-type').height() + $('.markets-area').first().next().children('div:nth-of-type(2)').height() + $('.markets-area').first().next().children('a').height();
  $('.markets-area').first().addClass('markets-area--active');
  $('.markets-area__text').first().addClass('markets-area--active').css('height', height + 90).css('opacity', '1');
});

$('.section--markets .markets__wrapper ul li').on('click', 'a', function(e){
  $('.section--markets .markets__wrapper ul li.active').removeClass('active')
  $(this).parent().addClass('active');
  var target = $(this).attr('href');

  $('.market-box').removeClass('active');
  $(target).addClass('active');
    e.preventDefault();
});
